import { Payment } from "../api";
import {
  showLoading,
  showError,
  setPaymentValue,
  increaseStepByOne,
  decreaseStepByOne,
  setStepInnerPage
} from "../actions";
import { 
  getCardId,
} from "../helpers";

const { paramCodes: { codigoAgente } } = require('../ecosystem.config.js');

export function quoterPurchaseNoCard(quoterData, currency) {
  return (dispatch, getState) => {
    const { client, payment, quotation, options } = getState();
    const { email } = client;

    const commonData = {
      Amount: payment.installments.amount, //monto total
      CardId: '0', //medio de pago
      Currency: currency, //tipo de moneda 'UYU o 'USD'
      Installments: payment.installments.value, //cantidad de cuotas
      QuotationNumber: quotation.quoteId, //id de la cotización
      Agency: codigoAgente,
    }

    const clientData = {
      DocumentType: client.documentType,
      DocumentNumber: client.documentNumber,
      Name: client.name,
      Gender: client.gender,
      FatherLastName: client.lastName,
      MotherLastName: null,
      Email: client.email,
      Department: client.addressState.label,
      City: client.addressCity.label,
      AddressName: client.addressStreet.value,
      AddressNameText: client.addressStreet.label,
      AddressNumber: client.addressNumber,
      AddressApto: client.addressApto,
    }

    const request = Object.assign({}, {
      email,
      paymentData: {
        Quoting: options.quoter, // Cotizador
        ...commonData,
        ...clientData,
        ...quoterData
      }
    });
    
    dispatch(showLoading(true));
    dispatch(setStepInnerPage('paymentMessage'));
    return Payment.quoterPurchaseNoCard(request).then(response => {
      if (response) {
        if(response.success) {
          dispatch(setPaymentValue('purchaseResult', true));
          dispatch(setPaymentValue('newPolicy', response.policy));
        } else {
          dispatch(setPaymentValue('errorMessage', response.message));
        }
      } else {
        dispatch(setPaymentValue('errorMessage', 'Ocurrió un error al tratar de realizar la compra por Redes de Cobranza'));
      }
      dispatch(showLoading(false));
    });
  };
}

export function quoterPurchase(pwToken, quoterData, currency) {
  return (dispatch, getState) => {
    
    const { client, payment, quotation, options } = getState();
    const { email } = client;

    const commonData = {
      Amount: payment.installments.amount, //monto total
      CardId: getCardId(payment.paymentType), //medio de pago
      Currency: currency, //tipo de moneda 'UYU o 'USD'
      Installments: payment.installments.value, //cantidad de cuotas
      QuotationNumber: quotation.quoteId, //id de la cotización
      Agency: codigoAgente,
    }

    const clientData = {
      DocumentType: client.documentType,
      DocumentNumber: client.documentNumber,
      Name: client.name,
      FatherLastName: client.lastName,
      MotherLastName: null,
      Email: client.email,
      Department: client.addressState.value,
      City: client.addressCity.value,
      AddressName: client.addressStreet.value,
      AddressNameText: client.addressStreet.label,
      AddressNumber: client.addressNumber,
      AddressApto: client.addressApto,
    }

    const request = Object.assign({}, {
      email,
      pwToken,
      paymentData: {
        Quoting: options.quoter, // Cotizador
        ...commonData,
        ...clientData,
        ...quoterData
      }
    });
    
    dispatch(showLoading(true));
    dispatch(setStepInnerPage('paymentMessage'));
    dispatch(setPaymentValue('openSiemprePago', false));
    
    return Payment.quoterPurchase(request).then(response => {
      if (response) {
        if(response.success) {
          dispatch(setPaymentValue('purchaseResult', true));
          dispatch(setPaymentValue('newPolicy', response.policy));
        } else {
          dispatch(setPaymentValue('errorMessage', response.message));
        }
      } else {
        dispatch(setPaymentValue('errorMessage', 'Ocurrió un error al tratar de efectuar el pago'));
      }
      dispatch(showLoading(false));
    });
  };
}